export default "__VITE_ASSET__C$un9kBP__"